export default __webpack_public_path__ + "static/media/inner3.133cb777.jpg";